module.exports = __webpack_public_path__ + "img/fusionlogo.a2cf2515.png";